import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { setActiveInstallation, setActiveStorage } from 'src/State/Storage/StorageActions'
import { useDispatch } from 'react-redux'
import { useTypedSelector } from 'src/State/RootReducer'
import { updateHeaderTab } from 'src/State/Navigation/NavigationActions'

type AvailableDashboardHeader = 0 | 1 | 2 | 3
/**
 * The hooks provides the current active installationId and storageId.
 *
 * It extract this information from the current route parameter for
 * installation-id, storage-id and dispatches them into the redux store.
 *
 * This hook is used for all pages under or related to the Installation dashboard page
 *
 * **Usage:**
 *
 * ```typescript
 * const {installationId, storageId} = useInstallationPages()
 * ```
 *
 *
 * This hook is just a workaround for a de-functioned navigation and routing policy
 *
 * TODO: restructure routes to  use nested routes, and with that context-specific data processing
 *
 * @param headerTab Tab-Index of the current active header navigation
 */
const useInstallationPages = (headerTab: AvailableDashboardHeader = 0): [string?, string?] => {
  const dispatch = useDispatch()
  const { installationId, storageId } = useParams<{ installationId: string; storageId: string }>()
  const { activeInstallation, activeStorage } = useTypedSelector(state => state.storage)

  useEffect(() => {
    dispatch(updateHeaderTab(headerTab))
  }, [dispatch, headerTab])

  useEffect(() => {
    if (installationId && parseInt(installationId) !== activeInstallation) {
      dispatch(setActiveInstallation(parseInt(installationId), storageId))
    }

    if (storageId && storageId !== activeStorage) {
      dispatch(setActiveStorage(storageId))
    }
  }, [storageId, installationId, dispatch, activeStorage, activeInstallation])

  return [installationId, storageId]
}

export default useInstallationPages
